module.exports = __webpack_public_path__ + "img/0010.a9e6f890.png";